import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const addCorporateRentalDiscount = (formData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CORPORATE_RENTAL_DISCOUNT_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/corporate-rental-discount/add`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CORPORATE_RENTAL_DISCOUNT_SUCCESS", payload: data });
        toast.success(data.message || "Discount added successfully");
      } else {
        dispatch({ type: "ADD_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: data });
        toast.error(data.message || "Failed to add discount");
      }
      return data;
    } catch (error) {
      dispatch({ type: "ADD_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to add discount");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateCorporateRentalDiscount = (formData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_CORPORATE_RENTAL_DISCOUNT_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/corporate-rental-discount/update`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_CORPORATE_RENTAL_DISCOUNT_SUCCESS", payload: data });
        toast.success(data.message || "Discount updated successfully");
      } else {
        dispatch({ type: "UPDATE_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: data });
        toast.error(data.message || "Failed to update discount");
      }
      return data;
    } catch (error) {
      dispatch({ type: "UPDATE_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to update discount");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const statusCorporateRentalDiscount = (formData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "STATUS_CORPORATE_RENTAL_DISCOUNT_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/corporate-rental-discount/update-status`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "STATUS_CORPORATE_RENTAL_DISCOUNT_SUCCESS", payload: data });
        toast.success(data.message || "Status updated successfully");
      } else {
        dispatch({ type: "STATUS_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: data });
        toast.error(data.message || "Failed to update status");
      }
      return data;
    } catch (error) {
      dispatch({ type: "STATUS_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to update status");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCorporateRentalDiscount = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_CORPORATE_RENTAL_DISCOUNT_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/corporate-rental-discount/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_CORPORATE_RENTAL_DISCOUNT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: data });
        toast.error(data.message || "Failed to fetch discount details");
      }
    } catch (error) {
      dispatch({ type: "VIEW_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to fetch discount details");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listCorporateRentalDiscount = (formData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_CORPORATE_RENTAL_DISCOUNT_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/corporate-rental-discount/list`,
        formData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_CORPORATE_RENTAL_DISCOUNT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: data });
        if (showLoader) toast.error(data.message || "Failed to fetch discount list");
      }
    } catch (error) {
      dispatch({ type: "LIST_CORPORATE_RENTAL_DISCOUNT_FAIL", payload: error.message });
      if (showLoader) toast.error(error?.response?.data?.message || "Failed to fetch discount list");
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const resetCorporateRentalDiscount = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_CORPORATE_RENTAL_DISCOUNT" });
  };
};